import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CentralModal } from "../CentralModal/CentralModal";
import "./centralGeneratePaymentLinkModal.css";
import { VENDORS } from "./constant";
import { CentralInputField } from "../CentralInputField/CentralInputField";
import { CentralSelect } from "../CentralSelect/CentralSelect";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";
import {
  getLinkForwardingService,
  getMobileHashingService,
} from "../../../_services";
import { configActions } from "../../../_actions";

export const CentralGeneratePaymentLinkModal = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOtherMobile, setIsOtherMobile] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [formData, setFormData] = useState({
    vendor: "",
    amount: "",
    mobileNumber: "",
    otherMobileNumber: "",
  });

  const reportingData = useSelector(
    (state) => state.centralReportingData?.reportingData
  );
  const appointmentId =
    reportingData.data[0].appointment_id || reportingData.data[0]._id;
  const mobileMasked = reportingData.data[0].mobile_masked;
  const patientName = reportingData.data[0].patient_name;
  const leadId = reportingData.data[0].lead_id;
  const appointmentType = reportingData.data[0].appointment_type;

  const MOBILE_NUMBER = [
    {
      label: mobileMasked,
      value: mobileMasked,
    },
    {
      label: "Others",
      value: "Others",
    },
  ];

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setFormData((prev) => ({
      vendor: "",
      amount: "",
      mobileNumber: "",
      otherMobileNumber: "",
    }));
    setIsSubmitDisabled(true);
    setIsOtherMobile(false);
  };

  const handleChange = (name, value) => {
    if (name === "mobileNumber") {
      if (value === "Others") {
        setIsOtherMobile(true);
      } else {
        setIsOtherMobile(false);
      }
    }
    if (name === "otherMobileNumber") {
      if (!/^\d{0,10}$/.test(value)) return;
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        return;
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const renderLinkApi = async (isQRCode = false) => {
    if (
      isOtherMobile &&
      (!formData.otherMobileNumber ||
        !/^[6-9]\d{9}$/.test(formData.otherMobileNumber))
    ) {
      toast.error(
        "Please enter a valid 10-digit mobile number."
      );
      return;
    }

    dispatch(configActions.showSpinningLoader());

    const baseData = {
      appType: "IPD_Admission",
      customerEmail: "",
      source: "hosChatApp",
      customerName: patientName,
      leadId,
      appointmentId,
      vendor: formData.vendor,
      amount: Number(formData.amount),
    };

    const sendLink = async (params) => {
      try {
        const res = await getLinkForwardingService(params);
        if (res.status === 200) {
          toast.success(
            isQRCode ? "QR Code sent successfully" : "Link sent successfully"
          );
        } else {
          toast.error(
            isQRCode ? "Failed to send QR Code" : "Failed to send link"
          );
        }
      } catch (err) {
        console.error("Link sending failed", err);
        toast.error(
          isQRCode ? "Failed to send QR Code" : "Failed to send link"
        );
      }
    };

    try {
      if (formData.otherMobileNumber) {
        const hashParam = { mobileNumber: [formData.otherMobileNumber] };

        try {
          const res = await getMobileHashingService(hashParam);
          const hashData = res?.result?.[0];

          if (!hashData?.isValid) {
            toast.error("Invalid mobile number. QR code sending failed.");
            return;
          }

          const params = {
            data: {
              ...baseData,
              field: "custom",
              mobile_hash: hashData.HashKey,
              mobile_masked: hashData.mobile_masked,
            },
            endPoint: isQRCode
              ? "sendAdvancePaymentQrV2"
              : "sendAdvancePaymentLinkV2",
            type: "parse",
          };

          await sendLink(params);
        } catch (hashError) {
          console.error("Hashing failed", hashError);
          toast.error("Unable to hash mobile number. QR code sending failed.");
        }
      } else {
        const params = {
          data: {
            ...baseData,
            field: "Mobile",
            index: 0,
          },
          endPoint: isQRCode
            ? "sendAdvancePaymentQrV2"
            : "sendAdvancePaymentLinkV2",
          type: "parse",
        };

        await sendLink(params);
      }
    } catch (err) {
      console.error("Unexpected error", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      dispatch(configActions.hideSpinningLoader());
      handleModalClose();
    }
  };

  const handleLinkSubmit = () => {
    renderLinkApi(false);
  };

  const handleQRSubmit = () => {
    renderLinkApi(true);
  };

  useEffect(() => {
    const mobileNumber =
      formData.mobileNumber === "Others"
        ? formData.otherMobileNumber
        : formData.mobileNumber;
    if (formData.amount && mobileNumber && formData.vendor) {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  }, [formData]);

  const renderModalData = () => {
    return (
      <>
        <span className="vendorSuggestText">
          Select vendor as 'Razorpay' for sending QR*
        </span>
        <div className="equipmentContentContainer">
          <CentralSelect
            value={formData.vendor || ""}
            label="Vendor *"
            options={VENDORS}
            formSx={{ marginTop: "5px !important" }}
            onChange={(event) => handleChange("vendor", event.target.value)}
          />
          <CentralInputField
            value={formData.amount || ""}
            label="Amount *"
            sx={{ marginTop: "5px !important" }}
            handleOnChange={(event) =>
              handleChange("amount", event.target.value)
            }
            type={"number"}
          />
          <CentralSelect
            value={formData.mobileNumber || ""}
            label="Mobile Number *"
            options={MOBILE_NUMBER}
            onChange={(event) =>
              handleChange("mobileNumber", event.target.value)
            }
          />
          {isOtherMobile ? (
            <CentralInputField
              value={formData.otherMobileNumber || ""}
              label="Enter Mobile Number *"
              handleOnChange={(event) =>
                handleChange("otherMobileNumber", event.target.value)
              }
              maxLength={10}
              type={"number"}
            />
          ) : (
            ""
          )}
          <Box className="link-button-container">
            <Button
              variant="contained"
              onClick={handleLinkSubmit}
              disabled={isSubmitDisabled}
              sx={{
                width: "fit-content",
                minWidth: "85px",
                background: "#3476CD",
                lineHeight: "18px",
              }}
            >
              Send Link
            </Button>
            {formData.vendor === "razorpay" ? (
              <Button
                variant="contained"
                onClick={handleQRSubmit}
                disabled={isSubmitDisabled}
                sx={{
                  width: "fit-content",
                  minWidth: "85px",
                  background: "#3476CD",
                  lineHeight: "18px",
                }}
              >
                Send QR Code
              </Button>
            ) : (
              ""
            )}
          </Box>
        </div>
      </>
    );
  };

  return (
    <div className="textReadOnlyRow">
      <span className="textReadOnlyLabel">Generate Payment Link</span>
      <CentralModal
        open={isModalOpen}
        onClose={handleModalClose}
        modalTitle={"Generate Payment Link"}
        sx={{ minHeight: "155px" }}
        modalButton={
          <div className="defaultModalButton" onClick={handleModalOpen}>
            Generate
          </div>
        }
      >
        {renderModalData()}
      </CentralModal>
    </div>
  );
};
